// ==============================================
// Centralized client-side session + token handling
// ==============================================
// Single source of truth for the logged-in user and JWT. When the backend
// starts issuing tokens (e.g. the JWT o_auth backend), login stores it here and
// every API request carries it automatically (see services/authFetch.js).

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};

export const getUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
};

export const setSession = (user, token) => {
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (token) localStorage.setItem(TOKEN_KEY, token);
};

export const clearSession = () => {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => !!getUser();

export const getRole = () => getUser()?.type || null;

// Spread into a fetch headers object to attach the bearer token explicitly.
export const authHeaders = (extra = {}) => {
  const token = getToken();
  return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
};

export const logout = () => {
  clearSession();
  window.location.href = '/login';
};
